fragment DiscountGroupFragment on DiscountGroup {
    id
    name
}